import { Stack } from '@mui/material'
import PRBarChart from 'pages/pranalysis/PRBarChart'
import ComponentBase from './ComponentBase'
import { usePRAnalysisAll } from 'hooks/pranalysis'


const PRAnalysis = () => {
    const { data } = usePRAnalysisAll()

    return (
        <ComponentBase
            title="広報活動診断"
            buttons={[{ label : '広報活動診断', to : '/pranalysis' }]}
        >
            {data && data.hasCompletedAnswer && (
            <Stack
                rowGap={3}
            >
                <PRBarChart type="経営者" />
                <PRBarChart type="担当者" />
            </Stack>
            )}
        </ComponentBase>
    )
}

export default PRAnalysis
